import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarModule } from 'primeng/sidebar';
import { LayoutService } from './service/app.layout.service';
import { UtilService } from '../_services/util.service';
import { ButtonModule } from 'primeng/button';
import { StorageService } from '../_services/storage.service';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-profilemenu',
  standalone: true,
  imports: [CommonModule, SidebarModule, ButtonModule, RouterModule],
  templateUrl: './app.profilemenu.component.html',
  styleUrl: './app.profilemenu.component.scss',
})
export class AppProfilemenuComponent implements OnInit {
  layoutService = inject(LayoutService);
  utilService = inject(UtilService);
  storageService = inject(StorageService);
  router = inject(Router);

  currentDateTime = new Date();
  formattedDateTime: string = '';
  currentTemperature: number | null = null;

  ngOnInit(): void {
    this.updateDateTime();
    this.utilService.getCurrentTemperature().subscribe((data: any) => {
      this.currentTemperature = data.current.temp_c;
    });
  }

  updateDateTime(): void {
    this.formattedDateTime = this.formatDateTime(this.currentDateTime);
    setInterval(() => {
      this.currentDateTime = new Date();
      this.formattedDateTime = this.formatDateTime(this.currentDateTime);
    }, 1000);
  }

  formatDateTime(date: Date): string {
    return date.toLocaleString('th-TH', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  }

  gotoProfile(): void {
    this.layoutService.hideSidebar();
    this.router.navigate(['/user-manage/user-profile']);
  }

  get visible(): boolean {
    return this.layoutService.state.profileSidebarVisible;
  }

  set visible(_val: boolean) {
    this.layoutService.state.profileSidebarVisible = _val;
  }
}
